export default "__VITE_ASSET__DGW4D2v2__"